var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardTodoDocument({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.17213 1.00749V3.88533C8.17213 4.27553 8.17213 4.47063 8.2503 4.61966C8.31906 4.75076 8.42878 4.85734 8.56374 4.92414C8.71716 5.00008 8.918 5.00008 9.31967 5.00008H12.2821M9.60656 8.48364H3.86885M9.60656 11.2705H3.86885M5.30328 5.69675H3.86885M8.17213 0.819702H4.44262C3.23759 0.819702 2.63508 0.819702 2.17482 1.04752C1.76996 1.24791 1.4408 1.56766 1.23451 1.96095C1 2.40806 1 2.99336 1 4.16396V11.4099C1 12.5805 1 13.1658 1.23451 13.6129C1.4408 14.0062 1.76996 14.3259 2.17482 14.5263C2.63508 14.7541 3.23759 14.7541 4.44262 14.7541H9.03279C10.2378 14.7541 10.8403 14.7541 11.3006 14.5263C11.7055 14.3259 12.0346 14.0062 12.2409 13.6129C12.4754 13.1658 12.4754 12.5805 12.4754 11.4099V5.00003L8.17213 0.819702Z",
    stroke: "#6987B4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardTodoDocument);
export default __webpack_public_path__ + "static/media/DashboardTodoDocument.3af2a84a0cc3cb3a11157f07cd3a951b.svg";
export { ForwardRef as ReactComponent };